import formatHelpers, { DateFormat } from '@helper/formatHelpers';
import { PharmacyType } from '@services/src/models';
import { Col, Row } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { Field } from 'formik';
import {
	FCheckbox,
	FDatePicker,
	FFieldLabel,
	FInput,
	FRadioGroup,
	FSpan,
} from 'forms/FormikFormItems';
import React from 'react';
import { Checkbox } from 'reakit';

import styles from '../styles/PharmacyEdit.module.less';

interface IProps {
	readOnly: boolean;
}

export const GeneralData = (props: IProps) => (
	<Col span={12}>
		<h2 className="header-text">General data</h2>

		<div className={styles.description}>
			<Row>
				<Col span={12}>
					<div className="fieldbox">
						<FFieldLabel label="Name" />
						<Field
							component={FInput}
							placeholder="Name"
							name="name"
							readOnly={true}
						/>
					</div>
				</Col>
				<Col span={11} offset={1}>
					<div className="fieldbox">
						<FFieldLabel label="Company Name" />
						<Field
							component={FInput}
							placeholder="Company Name"
							name="companyName"
							readOnly={props.readOnly}
						/>
					</div>
				</Col>
			</Row>

			<Row>
				<Col span={12}>
					<div className="fieldbox">
						<FFieldLabel label="Pharmacy Chain" />
						<Field
							component={FInput}
							placeholder="Pharmacy Chain"
							name="pharmacyChain"
							readOnly={true}
						/>
					</div>
				</Col>
				<Col span={11} offset={1}>
					<div className="fieldbox">
						<FFieldLabel label="NIP" />
						<Field
							component={FInput}
							placeholder="NIP"
							name="taxNumber"
							readOnly={props.readOnly}
						/>
					</div>
				</Col>
			</Row>
			<Row>
				<Col span={12}>
					<div className="fieldbox">
						<FFieldLabel label="Type" />
						<Field
							disabled={props.readOnly}
							style={{
								width: '100%',
							}}
							defaultValue={PharmacyType.PHARMACY}
							values={[
								PharmacyType.PHARMACY,
								PharmacyType.MEDICALSHOP,
							]}
							labels={['apteka', 'sklep medyczny']}
							component={FRadioGroup}
							name="type"
						/>
					</div>
				</Col>
				<Col span={11} offset={1}>
					<div className="fieldbox">
						<FFieldLabel label="IBAN" />
						<Field
							component={FInput}
							placeholder="IBAN"
							name="iban"
							readOnly={props.readOnly}
						/>
					</div>
				</Col>
			</Row>
			<Row>
				<Col span={6}>
					<div className="fieldbox">
						<FFieldLabel label="Credit notes approval" />
						<Field
							component={FCheckbox}
							placeholder="Credit notes approval"
							name="automaticNoteSending"
							id="automaticNoteSending"
							readOnly={props.readOnly}
						/>
					</div>
				</Col>

				<Col span={6}>
					<Field
						name="automaticNoteSendingLastChange"
						component={FSpan}
						tooltip="Last updated"
						format={(value: any) =>
							value
								? formatHelpers.formatDate(
										value,
										DateFormat.DateTime
								  )
								: ''
						}
					/>
				</Col>
				<Col span={11} offset={1}>
					<div className="fieldbox">
						<FFieldLabel label="Portal mail" />
						<Field
							component={FInput}
							placeholder="Portal mail"
							name="portalMail"
							readOnly={props.readOnly}
						/>
					</div>
				</Col>
			</Row>
			<Row>
				<Col span={11} offset={13}>
					<div className="fieldbox">
						<FFieldLabel label="Secondary portal mail" />
						<Field
							component={FInput}
							placeholder="Secondary portal mail"
							name="secondaryPortalMail"
							readOnly={props.readOnly}
						/>
					</div>
				</Col>
			</Row>
		</div>
	</Col>
);
